import React from 'react';
import PropType from 'prop-types';

export default function enhancerZoomHandlersHOC(Component) {
  class EnhancerZoomHandlers extends React.PureComponent {
    zoomOnMouseEnterHandler = () => {
      clearTimeout(this.mouseLeaveIndicator);
      this.props.updateZoomHovered(true);
    }

    zoomOnMouseLeaveHandler = () => {
      this.mouseLeaveIndicator = setTimeout(() => {
        this.props.updateZoomHovered(false);
      }, 250);
    }

    componentWillUnmount() {
      clearTimeout(this.mouseLeaveIndicator);
    }

    render () {
      return (
        <Component
          {...this.props}
          zoomOnMouseEnterHandler={this.zoomOnMouseEnterHandler}
          zoomOnMouseLeaveHandler={this.zoomOnMouseLeaveHandler}
        />
      );
    }
  }

  EnhancerZoomHandlers.propTypes = {
    updateZoomHovered: PropType.func.isRequired,
  };

  return EnhancerZoomHandlers;
}
